import { createEvent } from 'effector';

export const initializeBanks = createEvent<void>();
